/**
 * @return {void}
 */
module.exports = function removeSectionGates() {
    const sections = document.querySelectorAll('[data-component="sections"] .section-gated');
    sections.forEach((section) => {
        section.classList.remove('section-gated');
    });

    const titles = document.querySelectorAll('[data-component="sections"] .sections-contents-link--gated');
    titles.forEach((title) => {
        title.classList.remove('sections-contents-link--gated');

        const href = title.getAttribute("data-href");
        if (href) {
            title.setAttribute("href", href);
        }
    });
}
